import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper'
import SurveyService from 'app_services/admin/academicContent/survey/surveyService'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import StudentDashboardCustomTable from '../StudentDashboardCustomTable/StudentDashboardCustomTable'
import DataTableComponent from 'app_components/commons/dataTable';
import { useSelector } from 'react-redux';
import { CombinedReducers } from 'app_events/index';
import InteractionService from 'app_services/interaction/interactionService';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { RiSurveyLine } from 'react-icons/ri'
import TableItemsPaginator from 'app_components/modules/TableItemsPaginator/TableItemsPaginator';
import useWindowWidth from 'app_hooks/useWindowWidth';
import AccordionTable from 'app_components/modules/AccordionTable/AccordionTable';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';

interface IStudentDashboardSurveysTableProps {
  id?: string
}

const ITEMS_PER_PAGE = 10
const MOBILE_BREAKPOINT = 800

const StudentDashboardSurveysTable: FC<IStudentDashboardSurveysTableProps> = ({ id }) => {
  const surveyService = useMemo(() => new SurveyService(), [])
  const interactionService = useMemo(() => new InteractionService(), [])
  const [surveys, setSurveys] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const { windowWidth } = useWindowWidth()

  const getSurveys = useCallback(async () => {
    if (!courseSelected) return
    setIsLoading(true)
    const response = await surveyService.getAvailableUserSurveysByScheduling(courseSelected.courseScheduling)
    if (response?.code === 200 && response?.surveys?.length) {
      setSurveys(response.surveys)
    } else {
      setSurveys([])
    }
    setIsLoading(false)
  }, [surveyService, courseSelected])

  useEffect(() => {
    getSurveys()
  }, [getSurveys])

  const handleClickOpenSurvey = useCallback((survey: any) => {
    interactionService.addInteraction({
      academic_resource_config: survey.academic_resource_config,
      survey: survey.survey,
      surveyRelated: survey.surveyRelated,
      surveyRelatedContent: survey.surveyRelatedContent,
      typeInteraction: 'survey',
      config_category: ''
    }, 'survey')
  }, [interactionService])

  const headerKeys = useMemo(() => [
    'Curso',
    'Docente',
  ], [])

  const keys = useMemo(() => [
    'surveyRelatedContent.name',
    'surveyRelatedContent.teacher.profile.first_name',
  ], [])

  return (
    <div id={id} className='student-dashboard-surveys-table--layout'>
      <LoadingWrapper loading={isLoading} height="80px">
        <TableItemsPaginator items={surveys} perPage={ITEMS_PER_PAGE}>
          {(itemsToRender) => (
            windowWidth && windowWidth > MOBILE_BREAKPOINT ? (
              <StudentDashboardCustomTable>
                <DataTableComponent
                  data={itemsToRender}
                  textAlign='left'
                  headerKeys={headerKeys}
                  keys={keys}
                  detailsKey={[]}
                  tooltipKeys={['surveyRelatedContent.name']}
                  onModal={null}
                  hideTooltip
                  actionsColTitle='Ingreso a la evaluación'
                  rowButtons={(survey: any) => (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ButtonComponent onClick={() => handleClickOpenSurvey(survey)}>
                        <RiSurveyLine style={{ fontSize: '1.2rem' }} />
                      </ButtonComponent>
                    </div>
                  )}
                />
              </StudentDashboardCustomTable>
            ) : (
              <AccordionTable
                id={`${id}-accordion-table`}
                items={itemsToRender}
                renderContent={(item) => (
                  <div>
                    <ul>
                      <li>
                        <TextComponent>
                          <strong>Curso:</strong> {item?.surveyRelatedContent?.name}
                        </TextComponent>
                      </li>
                      <li>
                        <TextComponent>
                          <strong>Docente:</strong> {item?.surveyRelatedContent?.teacher?.profile?.first_name}
                        </TextComponent>
                      </li>
                      <li>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
                          <TextComponent>
                            <strong>Ingreso a la evaluación:</strong>
                          </TextComponent>
                          <ButtonComponent onClick={() => handleClickOpenSurvey(item)}>
                            <RiSurveyLine style={{ fontSize: '1.2rem' }} />
                          </ButtonComponent>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}
                renderHeader={(item) => (
                  <TextComponent fontSize="14px" elipsis>
                    {item?.surveyRelatedContent?.name}
                  </TextComponent>
                )}
              />
            )
          )}
        </TableItemsPaginator>
      </LoadingWrapper>
    </div>
  )
}

export default StudentDashboardSurveysTable
